import { useEffect, useState } from "react";
import { EnquireNowDrawerContent } from "./EnquireNowDrawerContent";
import { useLocation } from "@remix-run/react";
import { useCurrentRegion } from "~/lib/helpers/CurrencyHelper";
import { OhButton } from "~/components/ui/custom-radix-components/button";
import { PAGE_SECTION_IDS, PAGE_SECTION_SCROLL_CLASS } from "~/lib/constants/pageSectionIds";

interface StickyCTABannerProps {
    primaryButtonText?: string;
    secondaryButtonText?: string;
    // onPrimaryClick?: () => void;
    onSecondaryClick?: () => void;
    phoneNumber?: string;
    data?: any;
    region?: any;
}

export default function StickyCTABanner({
    primaryButtonText = "Enquire Now",
    secondaryButtonText = "",
    // onPrimaryClick,
    onSecondaryClick,
    phoneNumber = "",
    data,
    region,
}: StickyCTABannerProps) {
    // const [isVisible, setIsVisible] = useState(true);
    const [isEnquireNowOpen, setIsEnquireNowOpen] = useState(false);
    const [hideOnBottom, setHideOnBottom] = useState(false);

    const location = useLocation();
    const regionConfig = useCurrentRegion();
    let { pathname } = location;

    useEffect(() => {
        const handleScroll = () => {
            const scrollPos = window.innerHeight + window.scrollY;
            const pageHeight = document.body.offsetHeight;
            const isBottom = scrollPos >= pageHeight - 100;
            setHideOnBottom(isBottom);
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // const handlePrimaryClick = () => {
    //     if (onPrimaryClick) {
    //         onPrimaryClick();
    //     }
    // };

    const handleSecondaryClick = () => {
        if (onSecondaryClick) {
            onSecondaryClick();
        } else if (regionConfig?.phoneNumberWithCode) {
            window.location.href = `tel:${regionConfig?.phoneNumberWithCode}`;
        }
    };

    return (
        <div id={PAGE_SECTION_IDS.enquire} className={`fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 z-[39] transition-transform duration-300 ${PAGE_SECTION_SCROLL_CLASS}
            ${hideOnBottom ? "translate-y-full" : "translate-y-0"}`}>
            <div className="flex gap-4">
                <OhButton
                    variant="destructive"
                    className="flex-1 font-medium py-3 rounded-md"
                    onClick={(e) => {
                        e.stopPropagation();
                        setIsEnquireNowOpen(true);
                    }}
                >
                    {primaryButtonText}
                </OhButton>

                {isEnquireNowOpen && (
                    <EnquireNowDrawerContent
                        listing={data}
                        toggleEnquireModal={() => setIsEnquireNowOpen(false)}
                        isEnquireNowOpen={isEnquireNowOpen}
                        region={region}
                        path={pathname}
                    />
                )}
                {regionConfig?.phoneNumber && (
                    <OhButton
                        onClick={handleSecondaryClick}
                        className="flex-1 font-medium py-3 rounded-md"
                    >
                        Call {regionConfig?.phoneNumber || secondaryButtonText}
                    </OhButton>
                )}
            </div>
        </div>
    );
}